/**
 * Unified form validation utilities for auth forms.
 * Used by PasswordLoginForm, OtpLoginForm, MagicLinkForm, ForgotPasswordModal.
 */

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const validateEmail = (email) => {
  if (!email?.trim()) return { valid: false, message: 'Unesite email adresu' };
  if (!EMAIL_REGEX.test(email.trim())) return { valid: false, message: 'Unesite ispravnu email adresu' };
  return { valid: true };
};

export const validateRequired = (value, fieldName = 'Polje') => {
  if (!value?.trim()) return { valid: false, message: `${fieldName} je obavezno` };
  return { valid: true };
};

export const validateMinLength = (value, min, fieldName = 'Polje') => {
  if (value?.length < min) return { valid: false, message: `${fieldName} mora imati najmanje ${min} karaktera` };
  return { valid: true };
};

export const validateOtpCode = (code) => {
  if (!code || code.length !== 6) return { valid: false, message: 'Unesite 6-cifreni kod' };
  if (!/^\d{6}$/.test(code)) return { valid: false, message: 'Kod mora sadržati samo cifre' };
  return { valid: true };
};
